/*
@ see https://docs.google.com/spreadsheets/d/1fp2OxKG-o_CluiUurwf0mf6LcKBeO5iLNrQTYNAYIIU/edit#gid=0
*/
const BARRONS = {
  title: "Barron's",
  value: 'barrons',
  gams: true,
  defaultGroups: ['Dynamic Insets'],
  sizes: [
    {
      id: 'print-barrons',
      label: 'Print',
      columns: 1,
      width: 173,
      lines: 20,
      height: 180,
      minColumns: 1,
      maxColumns: 4,
      minWidth: 100,
      maxWidth: 728,
      minLines: 10,
      maxLines: 312,
      minHeight: 90,
      maxHeight: 2808,
      interactive: false,
      scale: 1,
      target: 'barrons',
      publish: 'print',
      group: 'Print',
    },
    {
      id: 'barrons-4col-image',
      gams: 'B300',
      OR: true,
      label: "Barron's 4 col (image)",
      width: 300,
      height: 200,
      interactive: false,
      scale: 2,
      target: 'barrons',
      publish: 'image',
      group: 'Images',
    },
    {
      id: 'b4u',
      label: "Barron's 4U/Margin",
      width: 300,
      height: 400,
      minWidth: 0,
      minHeight: 200,
      maxHeight: 3000,
      interactive: true,
      scale: 2,
      target: 'barrons',
      publish: 'inset',
      group: 'Dynamic Insets',
    },
    {
      id: 'barrons-8col-image',
      gams: 'B620',
      label: "Barron's 8 col (image)",
      width: 620,
      height: 412,
      interactive: false,
      scale: 2,
      target: 'barrons',
      publish: 'image',
      group: 'Images',
    },
    {
      id: 'barrons-8col-inset',
      label: "Barron's 8U/Margin",
      width: 620,
      height: 412,
      minWidth: 460,
      minHeight: 300,
      maxHeight: 3000,
      interactive: true,
      scale: 2,
      target: 'barrons',
      publish: 'inset',
      group: 'Dynamic Insets',
    },
    {
      id: 'barrons-12col-inset',
      label: "Barron's 12U/Margin",
      width: 940,
      height: 500,
      minWidth: 621,
      minHeight: 200,
      maxHeight: 3000,
      interactive: true,
      scale: 1,
      target: 'barrons',
      publish: 'inset',
      group: 'Dynamic Insets',
    },
    {
      id: 'barrons-16col-inset',
      label: "Barron's 16U/Margin",
      width: 1260,
      height: 500,
      minWidth: 941,
      minHeight: 200,
      maxHeight: 3000,
      interactive: true,
      scale: 1,
      target: 'barrons',
      publish: 'inset',
      group: 'Dynamic Insets',
    },
    {
      id: 'barrons-10col-image',
      gams: 'B780',
      label: "Barron's 10 col & Mobile Full Width (image)",
      width: 780,
      height: 520,
      interactive: false,
      scale: 2,
      target: 'barrons',
      publish: 'image',
      group: 'Images',
    },
    // {
    //   id: 'barrons-10col-inset',
    //   label: 'Barron\'s 12U/16U/Margin',
    //   width: 780,
    //   height: 520,
    //   minWidth: 700,
    //   minHeight: 400,
    //   maxHeight: 3000,
    //   interactive: true,
    //   scale: 2,
    //   target: 'barrons',
    //   publish: 'inset',
    //   group: 'Dynamic Insets',
    // },
    {
      id: 'barrons-fullscreen-image',
      gams: 'B1280',
      label: "Barron's Full Screen (image)",
      width: 1280,
      height: 853,
      interactive: false,
      scale: 2,
      target: 'barrons',
      publish: 'image',
      group: 'Images',
    },
    // {
    //   id: 'barrons-fullscreen-inset',
    //   label: 'Barron\'s Full Screen (inset)',
    //   width: 1280,
    //   height: 500,
    //   minWidth: 1030,
    //   minHeight: 400,
    //   maxHeight: 3000,
    //   interactive: true,
    //   scale: 2,
    //   target: 'barrons',
    //   publish: 'inset',
    //   group: 'Dynamic Insets',
    // },
    {
      id: 'thumb-barrons',
      gams: 'B105',
      label: "Barron's Thumbnail",
      width: 105,
      height: 70,
      interactive: false,
      scale: 2,
      target: 'barrons',
      publish: 'image',
      group: 'Thumbnails',
    },
    {
      id: 'thumbmobile-barrons',
      gams: 'B120',
      label: "Barron's Thumbnail Mobile",
      width: 120,
      height: 80,
      interactive: false,
      scale: 2,
      target: 'barrons',
      publish: 'image',
      group: 'Thumbnails',
    },
    {
      id: 'thumb8col-barrons',
      gams: 'B154',
      label: "Barron's Thumbnail 8 Col List",
      width: 154,
      height: 102,
      interactive: false,
      scale: 2,
      target: 'barrons',
      publish: 'image',
      group: 'Thumbnails',
    },
  ],
};

export const FALLBACK_SIZE = 'b4u';

export const STYLES =
  '\n@import url("https://asset.wsj.net/dynamic-insets/charts/barrons-digital.css");';

export default BARRONS;
